export default __webpack_public_path__ + "static/media/pg-39.a211fc28.jpg";